module.exports = __webpack_public_path__ + "img/nolan-color-wheel.7ba546fc.svg";